import React, { useCallback, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import {
  Runner,
  PhoneIcon,
  GraphUpIcon,
  ClockIcon,
  HandIcon,
  AdvantagesWave,
  AdvantagesPhone,
  WhiteEllipseImage,
  DefaultBlot,
} from 'src/assets';
import { ExpandMore } from '@mui/icons-material';
import './advantages.scss';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const Advantages = () => {
  const { t } = useTranslation();

  const [isExpandedRunner, setIsExpandedRunner] = useState(true);
  const [isExpandedPhone, setIsExpandedPhone] = useState(false);
  const [isExpandedGraph, setIsExpandedGraph] = useState(false);
  const [isExpandedClock, setIsExpandedClock] = useState(false);
  const [isExpandedHand, setIsExpandedHand] = useState(false);

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  const renderAccordion = useCallback(
    (expanded, onChange, title, subtitle, icon) => {
      return (
        <Accordion
          className={`advantages-accordion`}
          disableGutters
          expanded={expanded}
          onChange={() => onChange((prev) => !prev)}
        >
          <AccordionSummary className="advantages-accordion-summary" expandIcon={<ExpandMore />}>
            <div className="advantages-accordion-summary-image">
              <img src={icon} alt={icon} />
            </div>
            <h3>{t(title)}</h3>
          </AccordionSummary>
          <AccordionDetails className="advantages-accordion-details">
            <text>
              <Trans i18nKey={subtitle} />
            </text>
          </AccordionDetails>
        </Accordion>
      );
    },
    [t],
  );

  return (
    <>
      <div className="advantages-wave-wrapper">
        <div className="advantages-wave">
          <div className="advantages-wave-content">
            <img src={AdvantagesWave} alt={AdvantagesWave} />
          </div>
        </div>
      </div>
      <div className="advantages">
        <div className={`advantages-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
          <div className="advantages-title">
            <supertitle>{t('advantages:supertitle')}</supertitle>
            <h1 className="advantages-heading">
              {t('advantages:about')} <black-underline>{t('advantages:platform')}</black-underline>
            </h1>
          </div>
          <div className="advantages-section">
            <div className="advantages-section-left">
              <div className="advantages-section-left-content">
                <img
                  src={AdvantagesPhone}
                  alt={AdvantagesPhone}
                  className="advantages-section-left-image"
                />
                <img src={DefaultBlot} alt={DefaultBlot} className="advantages-image-2" />
              </div>
            </div>
            <div className="advantages-section-accordion">
              {renderAccordion(
                isExpandedRunner,
                setIsExpandedRunner,
                'advantages:highTitle',
                'advantages:highSub',
                Runner,
              )}
              {renderAccordion(
                isExpandedPhone,
                setIsExpandedPhone,
                'advantages:mobileTitle',
                'advantages:mobileSub',
                PhoneIcon,
              )}
              {renderAccordion(
                isExpandedGraph,
                setIsExpandedGraph,
                'advantages:marketTitle',
                'advantages:marketSub',
                GraphUpIcon,
              )}
              {renderAccordion(
                isExpandedClock,
                setIsExpandedClock,
                'advantages:optimTitle',
                'advantages:optimSub',
                ClockIcon,
              )}
              {renderAccordion(
                isExpandedHand,
                setIsExpandedHand,
                'advantages:usageTitle',
                'advantages:usageSub',
                HandIcon,
              )}
            </div>
          </div>

          <img src={WhiteEllipseImage} alt={WhiteEllipseImage} className="advantages-image-1" />
          <img src={WhiteEllipseImage} alt={WhiteEllipseImage} className="advantages-image-3" />
        </div>
      </div>
    </>
  );
};
